import { Typography, Button } from '@mui/material';
import useStore from '../../state-files/zustondStoreStates';
import { Box } from '@mui/system';
import UserListComponent from '../../discussions/UserListComponent';
import { useNavigate } from "react-router-dom";
import AddDiscussionMember from '../../discussions/AddDiscussionMemberWidget';
import fetchDiscussions from '../../helper-methods/fetchDiscussions';
import leaveDiscussion from '../../helper-methods/LeaveDiscussion';
import { useEffect, useState } from 'react';

const MobileUserListComponent = ({ chatId,
  setDiscussions, sortedUsers, chatAdmins, userList }) => {
  const { greenButtonSX } = useStore();
  const navigate = useNavigate();
  const [chatAdminSettings, setIsChatAdminSettings] = useState(false);
  const currentUserAdmin = chatAdmins?.includes(localStorage.getItem('userId'));


  return (
    <Box
      sx={{
        // 1. Match the title bar width exactly so it looks like one piece
        width: { xs: '85%' },

        // 2. THE FIX: Force it to be only as tall as the names inside
        height: "fit-content",

        // 3. Prevent the chat messages from "squishing" this box
        flexShrink: 0,

        maxHeight: "40vh",
        borderRadius: '5px',
        boxShadow: '3px 3px white',
        display: { xd: 'flex', md: 'none' },
        flexDirection: "column",
        overflowY: "auto",
        backgroundColor: "#FFFFFF",
        mb: 2,
        p: 1,
        borderLeft: "1px solid #e0e0e0",
        position: 'fixed'
      }}
    >

      <Box sx={[greenButtonSX, { marginBottom: 1 }]}>
        <Button
          id="leaveDiscussionButton"
          variant="body"
          color="none"
          onClick={async () => {
            const response = await leaveDiscussion(chatId);
            if (response === 200) {
              navigate('/discussions');
              fetchDiscussions(setDiscussions);
            }
          }}
          style={{ boxShadow: 'none' }}
        > Leave Discussion </Button>
      </Box>
      <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', pr: 1}}>
      <Typography
        variant="h6"
        sx={{ mb: 1, fontWeight: 'medium' }}
      >
        Users:
      </Typography>
        <AddDiscussionMember sx={{ display: currentUserAdmin ? '' : 'none', marginBottom: 1 }}
          isBold={true}
          chatId={chatId}
        />
      </Box>
      {/* Map each username to a Typography component */}
      {
        sortedUsers.map((name, index) => {
          var userInformation = userList.find(u => u.name === name);
          const isChatAdmin = chatAdmins?.includes(userInformation.id);
          return (
            <UserListComponent userInformation={userInformation} isChatAdmin={isChatAdmin} index={index} currentUserAdmin={currentUserAdmin} />
          )
        })}
    </Box>
  )
};

export default MobileUserListComponent;